import axios from 'axios'

export const getCurrentProjectInfo = async (idProject, params) => {
  const { data: partidas } = await axios.get(
    `/api/v1/proyectos/${idProject}/partidas?`,
    { params }
  )
  return partidas
}
